<template>
  <div class="w-full flex justify-evenly">
    <div
      v-wave
      class="flex justify-center items-center border border-gray-200 rounded-full flex-none p-5 sm:cursor-pointer"
      @click="onGooglePressed({'referral-code': referralCode})">
      <img
        v-if="!googleSignLoading"
        alt=""
        src="../../../assets/img/google.svg"
        class="w-6 h-6"/>
      <div v-else class="w-full h-full flex justify-center items-center ">
        <i class="pi pi-spinner pi-spin p-1"/>
      </div>
    </div>

    <div
      v-if="showLoginWithApple"
      v-wave
      class="flex justify-center items-center border border-gray-200 rounded-full flex-none p-5"
      @click="onApplePressed">
      <img
        v-if="!appleSignLoading"
        alt=""
        src="../../../assets/img/apple.svg"
        class="w-6 h-6"/>
      <div v-else class="w-full h-full flex justify-center items-center ">
        <i class="pi pi-spinner pi-spin p-1"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useSignInUp} from "@app/composables/signinup";
import { trackEvent } from '@app/composables/posthog';

defineProps({
  referralCode: {
    required: false,
    type: String,
    default : ''
  }
})
const {
  onApplePressed,
  showLoginWithApple,
  onGooglePressed,
  googleSignLoading,
  appleSignLoading
} = useSignInUp();

</script>

<style scoped lang="scss">

</style>
